package nl.volleyplanner.web.base.component

import kotlinx.html.*
import nl.volleyplanner.web.util.BootstrapColor

fun FlowContent.bootstrapAlert(bootstrapColor: BootstrapColor = BootstrapColor.Primary, block: DIV.() -> Unit) {
    div (classes = "alert") {
        classes += "alert-${bootstrapColor.cssName}"
        role = "alert"
        block()
    }
}